import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IonButton } from '@ionic/react';

import { loggedInSelector } from 'selectors/userSelector';

import AuthenticationActions from 'actions/AuthenticationActions';
import UnauthenticatedLayout from 'components/layouts/Unauthenticated';

export default function Logout() {
  const dispatch = useDispatch();
  const loggedIn = useSelector(loggedInSelector)

  useEffect(() => {
    if (loggedIn) dispatch(AuthenticationActions.logout());
  }, []);

  return (
    <UnauthenticatedLayout>
      <div className="ion-padding">
        <p>You are now logged out.</p>
        <IonButton routerLink="/login">Sign in</IonButton>
      </div>
    </UnauthenticatedLayout>
  );
};
